export const app = {
  connectToYourWhatsappNumber: 'WhatsApp Numaranıza Bağlan',
  connectYourWhatsappBotWithYourWhatsappNumber: 'WhatsApp Botunuzu WhatsApp numaranızla bağlayın',
  connect: 'Bağlan',
};
